import Joi, { number } from '@hapi/joi'

export const commonPackageCreationFilteringSchema = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please Select the Group `,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please Select the operationEntity`,
        "any.required": `operationEntityID required`
    }),
    collectionPointID: Joi.number().invalid().required().label("Collectionpoint").messages({
        "any.invalid": `Please Select the collectionPointID`,
        "any.required": `operationEntityID required`
    }),

}

export const commonpackageCreationSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select a Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select a Operatin Entity `,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Select a Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    aspNetUserId: Joi.number().label("User").messages({
        "any.invalid": `User cannot have invalid characters`,
        "any.required": `User required`
    }),
    operationalCardID: Joi.number().invalid(0).required().label("Operation Card").messages({
        "any.invalid": `Select a Operation Card`,
        "any.required": `Operation Card required`
    }),
    packageCode: Joi.string().required().min(2).max(2).label("Package Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Package Code required`,
        "string.pattern.base": `Package Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
    packageName: Joi.string().required().label("Package Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Package Name required`,
        "string.pattern.base": `Please enter valid package name`,
    }),
    backupLoginPassword: Joi.string().required().label("Backup login Password").

            min(8).
            max(50).
            regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/).
            error(errors => {
                errors.forEach(err => {
                    switch (err.type) {
                        case "any.empty":
                            err.message = "Backup Login Password Required!";
                            break;
                        case "string.min":
                            err.message = `Password should have at least ${err.context.limit} characters!`;
                            break;
                        case "string.max":
                            err.message = `Password should have at most ${err.context.limit} characters!`;
                            break;
                        default:
                            break;
                    }
                });
                return errors;
            })
            .messages({
                "string.pattern.base": `Password should have atleast 1 symbol,1 uppercase,1 number and 1 lowercase!`,
            }),
  
    isActive: Joi.boolean().label("Active"),
    removeUser: Joi.boolean().label("Remove User"),
    edit: Joi.boolean()
}

